window.ImageStripSlider = (function () {
  function init(rootId) {
    const root = document.getElementById(rootId);
    if (!root || root.dataset.istripInit) return;
    root.dataset.istripInit = 'true';

    const track = root.querySelector('[data-track]');
    const next = root.querySelector('[data-next]');
    const prev = root.querySelector('[data-prev]');
    if (!track) return;

    root.querySelectorAll('video.istrip__video').forEach(function (v) {
      v.muted = true;
      v.playsInline = true;
    });

    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        const vid = entry.target.querySelector('video.istrip__video');
        if (!vid) return;
        if (entry.isIntersecting) {
          const p = vid.play && vid.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          vid.pause && vid.pause();
        }
      });
    }, { root: track, threshold: 0.6 });
    root.querySelectorAll('.istrip__card').forEach(function (card) { io.observe(card); });

    function scrollOne(dir) {
      const card = track.querySelector('.istrip__card');
      if (!card) return;
      const gap = parseInt(getComputedStyle(track).gap) || 0;
      const cardWidth = card.offsetWidth + gap;
      track.scrollBy({ left: dir * cardWidth, behavior: 'smooth' });
    }
    next && next.addEventListener('click', function () { scrollOne(1); });
    prev && prev.addEventListener('click', function () { scrollOne(-1); });

    function updateNav() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (prev) prev.hidden = track.scrollLeft <= 0;
      if (next) next.hidden = track.scrollLeft >= maxScroll - 1;
    }
    track.addEventListener('scroll', updateNav);
    updateNav();

    // ---------- Autoplay ----------
    const autoplayEnabled = root.dataset.autoplay === 'true'
      && !matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayStyle = root.dataset.autoplayStyle === 'marquee' ? 'marquee' : 'step';
    const autoplaySpeed = (parseFloat(root.dataset.autoplaySpeed) || 4) * 1000;
    const pauseOnHover = root.dataset.autoplayPauseOnHover !== 'false';
    let autoplayTimer = null;
    let marqueeRaf = null;
    let marqueeLastTs = null;
    let autoplayPaused = false;

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
      if (marqueeRaf) {
        cancelAnimationFrame(marqueeRaf);
        marqueeRaf = null;
        marqueeLastTs = null;
      }
    }
    function startAutoplay() {
      if (!autoplayEnabled || autoplayPaused || autoplayTimer || marqueeRaf) return;
      if (autoplayStyle === 'marquee') {
        const card = track.querySelector('.istrip__card');
        const gap = parseInt(getComputedStyle(track).gap) || 0;
        const cardWidth = card ? card.offsetWidth + gap : 200;
        // Calibrated so one card-width scrolls by roughly every autoplaySpeed ms,
        // matching the pacing of step mode but as continuous motion instead of jumps.
        const pxPerMs = cardWidth / autoplaySpeed;
        const tick = function (ts) {
          if (marqueeLastTs === null) marqueeLastTs = ts;
          const dt = ts - marqueeLastTs;
          marqueeLastTs = ts;
          const maxScroll = track.scrollWidth - track.clientWidth;
          if (maxScroll > 0) {
            track.scrollLeft += pxPerMs * dt;
            if (track.scrollLeft >= maxScroll - 1) track.scrollLeft = 0;
          }
          marqueeRaf = requestAnimationFrame(tick);
        };
        marqueeRaf = requestAnimationFrame(tick);
      } else {
        autoplayTimer = setInterval(function () {
          const maxScroll = track.scrollWidth - track.clientWidth;
          if (track.scrollLeft >= maxScroll - 1) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            scrollOne(1);
          }
        }, autoplaySpeed);
      }
    }

    if (autoplayEnabled) {
      startAutoplay();

      if (pauseOnHover) {
        root.addEventListener('mouseenter', function () { autoplayPaused = true; stopAutoplay(); });
        root.addEventListener('mouseleave', function () { autoplayPaused = false; startAutoplay(); });
        root.addEventListener('touchstart', function () { autoplayPaused = true; stopAutoplay(); }, { passive: true });
        root.addEventListener('touchend', function () {
          autoplayPaused = false;
          setTimeout(startAutoplay, 2000);
        }, { passive: true });
      }

      next && next.addEventListener('click', function () { stopAutoplay(); autoplayPaused = false; startAutoplay(); });
      prev && prev.addEventListener('click', function () { stopAutoplay(); autoplayPaused = false; startAutoplay(); });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoplay();
        } else if (!autoplayPaused) {
          startAutoplay();
        }
      });
    }

    const isTouch = matchMedia('(pointer: coarse)').matches;
    if (isTouch) {
      const closeAll = function () {
        root.querySelectorAll('.istrip__hotspot-card.is-active').forEach(function (c) {
          c.classList.remove('is-active');
        });
      };
      root.querySelectorAll('.istrip__hotspot').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          const popup = btn.nextElementSibling;
          if (!popup || !popup.classList.contains('istrip__hotspot-card')) return;
          const open = popup.classList.contains('is-active');
          closeAll();
          if (!open) popup.classList.add('is-active');
          e.stopPropagation();
        });
      });
      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) closeAll();
      });
    }

    let lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    let revealTimer;
    function onScrollDirHide() {
      const y = window.pageYOffset || document.documentElement.scrollTop || 0;
      const scrollingUp = y < lastY;
      if (scrollingUp) {
        root.classList.add('hide-hotspots');
        root.querySelectorAll('.istrip__hotspot-card.is-active').forEach(function (c) {
          c.classList.remove('is-active');
        });
      } else {
        root.classList.remove('hide-hotspots');
      }
      clearTimeout(revealTimer);
      revealTimer = setTimeout(function () { root.classList.remove('hide-hotspots'); }, 220);
      lastY = y;
    }
    window.addEventListener('scroll', onScrollDirHide, { passive: true });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.istrip').forEach(function (el) { init(el.id); });
  }

  // Runs once on normal page load, and again whenever the theme editor
  // swaps in a re-rendered section (Section Rendering API) - script tags
  // in that swapped-in HTML never execute, so this listener is what
  // re-triggers init for a freshly-rendered instance instead.
  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });

  return { init: init, initAll: initAll };
})();
